export { default } from './UserMgmtInfoDialog'
export type { UserMgmtInfoDialogProps } from './UserMgmtInfoDialog'
